import { emergency, piggyBank, savings, shield } from "../Helper/svgs";

const WhatYouGetList = [
    {
        icon: shield,
        title: 'Safety, Trust and Capital Gains'
    }, 
    {
        icon: savings,
        title: 'Accumulate Long-term and Short-term Investment',
    },
    {
        icon: emergency, 
        title: 'Meet any Emergency expenses',
    },
    {
        icon: piggyBank,
        title: 'Accumulate wealth for Retirement',

    },
]

export default WhatYouGetList;